module.exports = "/_next/static/images/dna-spacer-strand-top-91c0c3a7396004f1c5fac900d037b9ee.png";